import { lazy } from 'react';

const SettingPage = lazy(() => import('../pages/Setting.page'));

export const SettingRoutes = [
    {
        path: 'setting',
        element: <SettingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];
